module.exports = __webpack_public_path__ + "img/icon_nongji.b30a1d50.png";